import { type AvailableSidebarThemeID, type SidebarSequenceWidgets, WidgetType } from '@common/types/Sidebar';
import { SidebarSequence } from '@common/types/SidebarSequenceByRoute';
import { ThemeID } from '@common/types/ThemeID';

/**
 * Configure which widgets are included for each platform and sequence.
 */
// prettier-ignore
export const PLATFORM_SIDEBAR_WIDGETS: Record<AvailableSidebarThemeID, SidebarSequenceWidgets> = {
    [ThemeID.AB]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
    [ThemeID.BB]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
    [ThemeID.BI]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
    [ThemeID.BR]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS
        ],
    },
    [ThemeID.MH]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
    [ThemeID.RW]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
    [ThemeID.SC]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
    [ThemeID.VI]: {
        [SidebarSequence.DEFAULT]: [WidgetType.RECENT_NEWS],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [WidgetType.PRO_NEWS],
        [SidebarSequence.RIGHT_COL_PODCAST]: [],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [WidgetType.RECENT_NEWS],
        [SidebarSequence.RIGHT_COL_MEDIA]: [WidgetType.MOST_VIEWED],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [],
        [SidebarSequence.RIGHT_COL_MISC]: [WidgetType.RECENT_NEWS],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.RECENT_NEWS,
            WidgetType.PRO_NEWS,
            WidgetType.MOST_READ,
        ],
    },
    [ThemeID.VN]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.TRANSFER_RUMOUR,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS,
        ],
    },
    [ThemeID.VP]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.TRANSFER_RUMOUR,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED,
            WidgetType.TRANSFER_RUMOUR,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.TRANSFER_RUMOUR,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.TRANSFER_RUMOUR,
            WidgetType.LATEST_PODCASTS,
        ],
    },
    [ThemeID.VPBE]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS,
        ],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_COMMENTED,
            WidgetType.MOST_LIKED_COMMENTS,
            WidgetType.MOST_READ,
            WidgetType.LATEST_PODCASTS,
        ],
    },
    [ThemeID.WH]: {
        [SidebarSequence.DEFAULT]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.PREMIUM_HOMEPAGE]: [],
        [SidebarSequence.RIGHT_COL_ARTICLE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_HOMEPAGE]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_MEDIA]: [
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MEDIA_INDEX]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
        [SidebarSequence.RIGHT_COL_MISC]: [
            WidgetType.MOST_READ
        ],
        [SidebarSequence.RIGHT_COL_PODCAST]: [
            WidgetType.MOST_READ,
            WidgetType.MOST_VIEWED
        ],
    },
};
